"use client";
import React, { useState, useEffect, useCallback } from "react";
import { PROJECTS } from "./ProjectData";
import { getAllPortfolioList } from "@/lib/ApiClient";
import { getPortfolioProject } from "@/lib/Utility";
import { getPortfolioDetailsByID } from "@/lib/ApiClient";
import SuccessStoryPopup from "@/app/success-stories/components/SuccessStoryPopup";
import {
  portfolioModalInterface,
  PortfolioAllListInterface,
} from "@/lib/Types";
import TruncatedDescription from "../TruncatedDescription";
import PortfolioCard from "./PortfolioCard";
import { useIsMobile } from "@/hooks/useMediaQuery";

interface successStoriesProps {
  Heading: React.ReactNode;
  desc: string;
  ctaButton: React.ReactNode;
}

export default function SuccessStory({
  Heading,
  desc,
  ctaButton,
}: successStoriesProps) {

  const [portfolioArr, setPortfolioArr] =
    useState<PortfolioAllListInterface[]>(PROJECTS);
  const [selectedPortfolio, setSelectedPortfolio] = useState(0);
  const [portfolioDetails, setPortfolioDetails] = useState<
    portfolioModalInterface | undefined
  >();
  const portfolioArray = async () => {
    try {
      const data = await getAllPortfolioList(1, 10);
      const unifiedArr = getPortfolioProject(data || []);
      setPortfolioArr(
        unifiedArr?.length > 3 ? unifiedArr?.slice(0, 2) : unifiedArr,
      );
    } catch (err: any) {
      console.log(err?.message);
    }
  };

  const fetchSelectedID = useCallback(async () => {
    if (!selectedPortfolio) return;
    try {
      const data = await getPortfolioDetailsByID(selectedPortfolio);
      setPortfolioDetails(data);
    } catch (err: unknown) {
      console.error(
        err instanceof Error
          ? err.message
          : "Failed to fetch portfolio details",
      );
    }
  }, [selectedPortfolio]);

  useEffect(() => {
    portfolioArray();
  }, []);

  useEffect(() => {
    fetchSelectedID();
  }, [fetchSelectedID]);
  const isMobile = useIsMobile()
  if (isMobile === true) return null;

  return (
    <>
      {selectedPortfolio !== 0 && (
        <SuccessStoryPopup
          onClose={() => setSelectedPortfolio(0)}
          portfolioDetails={portfolioDetails}
        />
      )}

      <section className="success-story bg-[#000000] w-full relative overflow-hidden">
        <div className="texture-bg mix-blend-overlay bg-repeat w-full h-full absolute top-0 left-0 z-0" />

        <div className="w-[907.05px] h-[907.05px] bg-[#225bd4]/40 rounded-full blur-[333.68px] absolute right-0 top-0 transform translate-x-1/3 -translate-y-1/3" />
        <div className="w-[907.05px] h-[907.05px] bg-[#225bd4]/40 rounded-full blur-[333.68px] absolute left-0 bottom-0 -translate-x-1/3 translate-y-1/3" />

        <div className="max-w-[5000px] mx-auto w-[calc(100%_-_15%)] py-[50px] lg:py-[150px] relative z-1">
          <p className="self-stretch text-[#fff] text-base font-medium uppercase tracking-tight pb-3 lg:pb-8">
            Success Stories
          </p>
          <div className="success-story-header flex flex-col lg:flex-row items-start justify-between gap-[20px]">
            <div className="success-story-header-left lg:basis-1/2 w-full leading-[110%]">
              {Heading}
            </div>

            <div className="success-story-header-right lg:basis-1/2 w-full flex flex-col gap-[40px]">
              <div className="text-[#fff]/70 text-[length:var(--hero-para)] font-normal leading-[150%]">
                <TruncatedDescription text={desc} />
              </div>
              {ctaButton}
            </div>
          </div>

          <div className="success-story-content grid grid-cols-1 2xl:grid-cols-2 gap-[60px] pt-[20px] lg:pt-[100px]">
            {portfolioArr?.length > 0
              ? portfolioArr?.map((project) => (
                <PortfolioCard
                  key={project.id}
                  project={project}
                  setSelectedPortfolio={setSelectedPortfolio}
                />
              ))
              : null}
          </div>
        </div>
      </section>
    </>
  );
}
